import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Tree from 'components/Tree'
import Flex from 'components/Flex'

const Wrapper = styled(Flex)`
  padding: 20px 20px 20px 0;
  gap: 5px;
`

const DegreeAndDepartmentFilter = ({ 
  cardNumber,
  degreeList, 
  setDegreeList,
  setSpecializationList,
  filterData,
  checkedDegreeData,
  checkedKeys,
  setCheckedKeys 
}) => {

  const [tapNumber,setTapNumber] = useState(null);
  
  // Initialize checkedKeys from parent component if available

  useEffect(() => {
    if(cardNumber!=tapNumber){
      setTapNumber(cardNumber);
      setCheckedKeys([]);
    }
    if (filterData === null || filterData === true) {
    setCheckedKeys([]);
  }
  },[cardNumber,filterData]);

  const onCheck = (activeKeys, info) => {
    setCheckedKeys(activeKeys)
    
    // Separate department IDs and specialization IDs
    const departmentIds = []
    const specializationIds = []
    const halfCheckedKeys = info?.halfCheckedKeys || []
    
    const fullyCheckedDepartments = []
    info?.checkedNodes?.forEach(node => {
      const isHalfChecked = halfCheckedKeys.includes(node?.key);
      
      if (!node?.isSpecialization && !isHalfChecked) {
        fullyCheckedDepartments.push(node?.value)
        departmentIds.push(node?.value)
      }
    })
    
    info?.checkedNodes?.forEach(node => {
      if (node?.isSpecialization) {
        let parentDepartment = null
        
        degreeList?.forEach(degree => {
          degree?.children?.forEach(department => {
            const hasThisSpec = department?.children?.some(spec => 
              spec?.value === node?.value
            );
            if (hasThisSpec) {
              parentDepartment = department?.value
            }
          })
        })
        
        if (!fullyCheckedDepartments.includes(parentDepartment)) {
          specializationIds.push(node?.value)
        }
      }
    })
    
    halfCheckedKeys?.forEach(key => {
      const node = info?.checkedNodes?.find(n => n?.key === key) || 
                   info?.halfCheckedKeys && degreeList?.flatMap(d => d.children || []).find(dept => dept?.key === key)
      
      if (node && !node?.isSpecialization && !departmentIds.includes(node?.value)) {
      }
    })
    
    setDegreeList(departmentIds)
    setSpecializationList(specializationIds)
  }

  return (
    <Tree treeData={degreeList} checkedKeys={checkedKeys}  onCheck={onCheck} />
  )
}

export default DegreeAndDepartmentFilter